/* eslint-disable */
const ZMYDataCollectionUrl =
  'https://wxapp.gz-cmc.com/wxapp/static/zmy-data-collection-2.0.0.min.js';
const { NANFANG_KEY, NANFANG_DOMAIN, NANFANG_TENANT_CODE } = process.env;
export type ShareChannelType =
  | 'ChannelWechat'
  | 'ChannelTimeLine'
  | 'ChannelSina'
  | 'ChannelQQ'
  | 'ChannelMeeTime'
  | 'ChannelAlbum';

class NanFang {
  /**
   * 引入 script 脚本
   * @param url
   * @param name
   * @param loadCb
   * @param errofCb
   * @returns
   */
  static #loadScript(
    url: string,
    id: string,
    loadCb?: Function,
    errofCb?: Function,
  ) {
    const existScript = document.querySelector(`script[id=${id}]`);
    if (existScript) {
      if (loadCb) {
        loadCb();
      }
      return;
    }
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.setAttribute('id', id);
    script.onerror = (err) => {
      if (errofCb) {
        errofCb(err);
      }
    };
    script.onload = () => {
      if (loadCb) {
        loadCb();
      }
    };
    script.src = url;
    document.getElementsByTagName('html')[0].append(script);
  }

  /**
   * 根据userAgent判断当前环境
   * @returns
   */
  static #browerVersion() {
    const { userAgent } = navigator;
    const userIdMatchs = userAgent.match(/userId\/(.*?) /);
    const weixinVersion = userAgent.match(/MicroMessenger\/([\d.]+)/i);
    return {
      trident: userAgent.indexOf('Trident') > -1, // IE内核
      presto: userAgent.indexOf('Presto') > -1, // opera内核
      webKit: userAgent.indexOf('AppleWebKit') > -1, // 苹果、谷歌内核
      gecko:
        userAgent.indexOf('Gecko') > -1 && userAgent.indexOf('KHTML') === -1, // 火狐内核
      mobile: !!userAgent.match(/AppleWebKit.*Mobile.*/), // 是否为移动终端
      ios: !!userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), // ios终端
      android:
        userAgent.indexOf('Android') > -1 || userAgent.indexOf('Adr') > -1, // android终端
      iPhone: userAgent.indexOf('iPhone') > -1, // 是否为iPhone或者QQHD浏览器
      iPad: userAgent.indexOf('iPad') > -1, // 是否iPad
      webApp: userAgent.indexOf('Safari') === -1, // 是否web应该程序，没有头部与底部
      weixin: userAgent.indexOf('MicroMessenger') > -1, // 是否微信
      myApp: userAgent.indexOf('pdmiryun') > -1, // 在app里面打开
      rmcb: userAgent.indexOf('rmcb') > -1, // 在融媒采编app里面打开
      userId: userIdMatchs?.length ? userIdMatchs[1].replace(/ /g, '') : '',
      iframe: window.self !== window.top,
      windowWeixin: userAgent.indexOf('WindowsWechat') > -1,
      macWeixin: userAgent.indexOf('MacWechat') > -1,
      wxVersion: weixinVersion && weixinVersion.length ? weixinVersion[1] : 0,
      wxWork: userAgent.indexOf('WxWork') > -1,
      miniProgram: userAgent.indexOf('miniProgram') > -1,
      harmonyOS:
        userAgent.includes('OpenHarmony') || userAgent.includes('ArkWeb'),
    };
  }

  /**
   * 获取平台信息
   * @returns
   */
  static #getPlatform() {
    const version = NanFang.#browerVersion();
    let platform = '';
    if (version.android && version.myApp) {
      platform = 'Android';
    } else if (version.ios && version.myApp) {
      platform = 'iOS';
    } else if (version.harmonyOS && version.myApp) {
      platform = 'Android';
    } else if (version.mobile) {
      platform = 'Mobile';
    } else {
      platform = 'PC';
    }
    return platform;
  }

  /**
   * 初始化南方数据采集
   */
  static init() {
    return new Promise((resolve) => {
      if (
        process.env.NODE_ENV === 'development' ||
        this.#browerVersion().myApp
      ) {
        resolve(false);
        return;
      }
      this.#loadScript(ZMYDataCollectionUrl, 'ZMYDataCollection', () => {
        window.ZMYDataCollection.init({
          tenant_code: NANFANG_TENANT_CODE,
          key: NANFANG_KEY,
          domain: NANFANG_DOMAIN,
        });
        resolve(true);
      });
    });
  }

  /**
   * 上传打开文章数据
   */
  static openArticle(articleId: string) {
    if (process.env.NODE_ENV === 'development' || this.#browerVersion().myApp) {
      return;
    }
    window.ZMYDataCollection.openArticle({
      article_id: articleId,
      platform: this.#getPlatform(),
      user_id: NanFang.#browerVersion().userId,
      refer: document.referrer,
    });
  }

  /**
   * 上传评论文章数据
   * @param articleId
   */
  static commentArticle(articleId: string) {
    if (process.env.NODE_ENV === 'development' || this.#browerVersion().myApp) {
      return;
    }
    window.ZMYDataCollection.commentArticle({
      article_id: articleId,
      platform: this.#getPlatform(),
      user_id: NanFang.#browerVersion().userId,
      refer: document.referrer,
    });
  }

  /**
   * 上传点赞文章数据
   * @param articleId
   */
  static likeArticle(articleId: string) {
    if (process.env.NODE_ENV === 'development' || this.#browerVersion().myApp) {
      return;
    }
    window.ZMYDataCollection.likeArticle({
      article_id: articleId,
      platform: this.#getPlatform(),
      user_id: NanFang.#browerVersion().userId,
      refer: document.referrer,
    });
  }

  /**
   * 上传分享文章数据
   * @param articleId
   */
  static shareArticle(articleId: string, shareChannel: ShareChannelType) {
    if (process.env.NODE_ENV === 'development' || this.#browerVersion().myApp) {
      return;
    }
    window.ZMYDataCollection.shareArticle({
      article_id: articleId,
      share_channel: shareChannel,
      platform: this.#getPlatform(),
      user_id: NanFang.#browerVersion().userId,
      refer: document.referrer,
    });
  }
}

export default NanFang;
